<template>
  <v-dialog v-model="dialog" persistent width="90%">
    <v-card>
      <v-toolbar flat class="k-orange-linear">
        <v-toolbar-title class="white--text pl-4 py-3">
          {{ type === 'notification_schedule' ? 'Gestiones' : type === 'due' ? 'Cuotas' : 'Pagos' }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <data-table v-if="type !== 'due'" :url="url" :limit="5" :fields="movementFields" :searchOnCreate="false" :bus="bus" :content="movementList" container-classes="pa-0" row-classes="pa-0">
        </data-table>
        <template v-else>
          <v-expansion-panel class="elevation-0">
            <v-expansion-panel-content v-for="(item,i) in items" :key="i">
              <div slot="header">
                <v-layout row wrap :key="i">
                  <v-flex md12 class="f1em">
                    <span class="k-grey-text">{{item.descrip}}</span>
                  </v-flex>
                </v-layout>
              </div>
              <v-card>
                <v-card-text>
                  <v-layout row wrap class="ml-4">
                    <v-flex xs3 v-if="!Array.isArray(items2)" v-for="(items2, i) in JSON.parse(item.details)" :key="i">
                      <v-layout row wrap>
                        <v-flex xs12 class="f1em grey--text">
                          {{items2.name}}
                        </v-flex>
                        <v-flex xs12>
                          {{items2.type !== 'str' && items2.type !== 'int' ? items2.type === 'date' ? formatDate(items2.value, 'YYYY-MM-DD', 'DD/MM/YYYY') : new Intl.NumberFormat('es-VE').format(items2.value) : items2.value}}
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 v-else>
                      <v-layout row wrap class="py-3">
                        <v-flex xs v-for="(items3, i) in items2" :key="i">
                          <v-layout row wrap>
                            <v-flex xs12 class="f1em grey--text">
                              {{items3.name}}
                            </v-flex>
                            <v-flex xs12>
                              {{items3.type !== 'str' && items3.type !== 'int' ? items3.type === 'date' ? formatDate(items3.value, 'YYYY-MM-DD', 'DD/MM/YYYY') : new Intl.NumberFormat('es-VE').format(items3.value) : items3.value}}
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click.native="dialog = false">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue';
  import moment from 'moment';
  import EventBus from '@/event-bus';
  import DataTable from '@/components/global/DataTable';
  import DuesList from '@/components/customer/DuesList';
  import NotificationSchedulesList from '@/components/notification_schedule/NotificationScheduleList';
  import PaymentsList from '@/components/chat_center/PaymentsList';

  Vue.component('notificationSchedulesList', NotificationSchedulesList);
  Vue.component('duesList', DuesList);
  Vue.component('paymentsList', PaymentsList);

  export default {
    components: {
      DataTable,
    },
    created() {
      EventBus.$on('showMovements', (type, id) => {
        this.type = type;
        this.id = id;
        this.dialog = true;
      });
    },
    destroyed() {
      EventBus.$off('showMovements');
    },
    data() {
      return {
        dialog: false,
        bus: {
          update: 'updateMovements',
          clearItems: 'clearMovements',
          total: 'total',
        },
        items: [],
        type: '',
        id: 0,
        bill_details: [],
      };
    },
    computed: {
      url() {
        return `customers/${this.id}/${this.type}s`;
      },
      movementList() {
        let type = 'notificationScheduleList';
        if (this.type === 'payment') {
          type = 'paymentsList';
        } else if (this.type === 'due') {
          type = 'duesList';
        }
        return type;
      },
      movementFields() {
        let fields = 'reference,date,number,control,due_date,expires_date,descrip,amount,tax,total,balance';
        if (this.type === 'payment') {
          fields = 'paymentMethod.name,invoice.balance,invoice.expires_date,invoice.total,invoice.descrip,files.name,files.original_name,date,amount,reference,internal_ref,descrip,code,batch,recipient,remote_ip';
        } else if (this.type === 'due') {
          fields = 'company_id,customer_id,account,number,due_date,delinquency,descrip,details,due_balance,invoiced_balance,created_at';
        }
        return fields;
      },
    },
    methods: {
      formatDate(date, dateFormat, toFormat) {
        return moment(date, dateFormat).format(toFormat);
      },
      getStep(event, i) {
        if (event) {
          this.axios.get(`customers/${this.items[i].id}/bill_details?fields=amount,descrip,number,reference&paginate=0`).then((resp) => {
            this.bill_details = resp.data;
          });
        }
      },
    },
    watch: {
      dialog(newVal) {
        if (newVal) {
          if (this.type === 'due') {
            this.axios.get(`${this.url}?fields=${this.movementFields}&paginate=0`).then((resp) => {
              this.items = resp.data;
            });
          } else {
            EventBus.$emit('updateMovements');
          }
        } else {
          setTimeout(() => {
            EventBus.$emit('clearMovements');
          }, 300);
        }
      },
    },
  };
</script>

<style>
  #empty-table {
    margin: 16px;
  }

  table.table thead tr th.k-orange-linear.custom-colors {
    color:grey !important;
    background-color: white !important;
  }

  .expansion-panel__container.custom-header .expansion-panel__header .header__icon i {
    color:white !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/chat_center/CustomerMovements.vue